import MaskedInput from 'react-text-mask'
export * from 'react-text-mask'
const defaultMaskedInput = typeof MaskedInput === 'function' ? MaskedInput : MaskedInput.default
export { defaultMaskedInput as default }
